import React from 'react';
import { Link } from 'react-router-dom';
import {
  Col,
  Row,
} from 'react-bootstrap';
import AlertsCollection from 'components/AlertsCollection';
import CentralizedSpinner from 'components/CentralizedSpinner';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import mapAnnotations from 'helper/Meteorology/Weather/Overview/AnomalyPanel/mapAnnotations';
import Selector from 'components/DesignSystem/Selector';

import './index.scss';

export default function AnomalyPanel({
  isFetching,
  image,
  error,
  period,
  setPeriod,
  periodOptions,
}: {
  isFetching: boolean,
  image: string,
  error: boolean,
  period: string,
  setPeriod: React.Dispatch<React.SetStateAction<string>>,
  periodOptions: { value: string; label: string; }[],
}) {
  if (isFetching) {
    return <CentralizedSpinner />;
  }

  return (
    <>
      <Row className="mx-3">
        <Col md={8} className="anomaly-title">
          Anomalia da TSM
        </Col>
        <Col md={4}>
          <Selector id="periodSelect" value={period} setValue={setPeriod}>
            {periodOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </Selector>
        </Col>
      </Row>
      {error || !image ? (
        <div className="mt-4">
          <AlertsCollection
            alerts={[{ title: '', message: 'Imagem indisponível', variant: 'warning' }]}
          />
        </div>
      ) : (
        <>
          <div className="anomaly-map">
            <EnlargeableImage src={`data:image/png;base64,${image}`} className="mt-3" />
            <div className="map-tropics" />
            {mapAnnotations.map((annotation) => (
              <Link
                id={`map-annotation-${annotation.url}`}
                to={`/meteorology/weather/oscillations/${annotation.url}`}
                className="map-annotation"
                key={annotation.acronym}
                style={{ left: `${annotation.left}%`, top: `${annotation.top}%` }}
              >
                {annotation.acronym}
              </Link>
            ))}
          </div>
          <Row className="mx-4 mt-3">
            {mapAnnotations.map((legend) => (
              <Col key={legend.acronym} md={6} lg={4} className="text-start my-2">
                <Link
                  id={`legend-${legend.url}`}
                  to={`/meteorology/weather/oscillations/${legend.url}`}
                  className="map-legend-label"
                >
                  {`${legend.acronym} - ${legend.label}`}
                </Link>
              </Col>
            ))}
          </Row>
        </>
      )}
    </>
  );
}
